import * as _ from "lodash";
import axios from "axios";
import { getEnv } from "../utils/env";

export const baseURL = getEnv("REACT_APP_CHAT_SERVICE_ORIGIN");

const http = axios.create({
  baseURL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

http.interceptors.request.use((config) => {
  const domain = _.get(config, "domain");
  const timeZone = sessionStorage.getItem("timeZone") || null;

  const raw = localStorage.getItem(`${domain}_socket_token`);

  try {
    const data = JSON.parse(raw);
    const socketToken = _.get(data, "socketToken", "");

    if (socketToken) {
      config.headers.Authorization = `Bearer ${socketToken}`;
    }

    if (timeZone) {
      config.headers["X-Time-Zone"] = timeZone;
    }

    return config;
  } catch {
    localStorage.removeItem(`${domain}_socket_token`);
  }
});

http.interceptors.response.use(
  (response) => _.get(response, "data"),
  async (error) => {
    throw _.get(error, "response.data", {});
  }
);

export default http;
